import type {
  PlayerProfileResponse,
  TeamTargetResponsePagedData,
} from '@on3/api';
import { DatabaseLayout } from '@public/components/Layouts/DatabaseLayout';
import { Pagination } from '@public/components/UI/Pagination/Pagination';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import { CompactHeader } from '../Header/CompactHeader';
import { PlayerInterestsHeader } from './PlayerInterestsHeader';
import { PlayerInterestsItem } from './PlayerInterestsItem';
import styles from './PlayerInterestsPage.module.scss';

export interface InterestPageResponse {
  teamTargets?: TeamTargetResponsePagedData | null;
  basicInfo?: PlayerProfileResponse | null;
}

export const InterestsPage = ({
  teamTargets,
  basicInfo,
}: InterestPageResponse) => {
  const { list, pagination } = teamTargets || {};
  const [pageNumber, setPageNumber] = useState(pagination?.currentPage);
  const router = useRouter();
  const hasPagination = pagination?.count && pagination?.count > 25;

  const handleChange = useCallback(
    (event: any, value: any) => {
      setPageNumber(value);
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: value },
      });
    },
    [router],
  );

  return (
    <DatabaseLayout>
      <section>
        <CompactHeader basicInfo={basicInfo} recruitingLink={true} />
        <section>
          {!!hasPagination && (
            <Pagination
              className={styles.pagination}
              count={pagination?.pageCount}
              onChange={handleChange}
              page={pageNumber}
            />
          )}
          <PlayerInterestsHeader
            positionAbbreviation={list ? list[0]?.positionAbbreviation : 'pos'}
          />
          <ul>
            {list?.map((team) => (
              <PlayerInterestsItem key={team?.team?.key} {...team} />
            ))}
          </ul>
          {!!hasPagination && (
            <Pagination
              count={pagination?.pageCount}
              onChange={handleChange}
              page={pageNumber}
            />
          )}
        </section>
      </section>
    </DatabaseLayout>
  );
};
